import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useQuery } from "@tanstack/react-query";
import { useSharedViewContext } from "@/contexts/SharedViewContext";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { getPublicSharedViewWorkspacePropertyGroupsQueryOptions } from "@/queries/shared-views/fetchers";
import { getWorkspacePropertyGroupsQueryOptions } from "@/queries/workspace/fetchers";
import type { PropertyVisibilityFilter } from "@/types/property";
export function usePropertyGroups(t0, visibility) {
  const $ = _c(10);
  const shouldFilterByPropertyGroupIds = t0 === undefined ? false : t0;
  const sharedViewContext = useSharedViewContext();
  const {
    workspaceId
  } = useCurrentWorkspace();
  const t1 = sharedViewContext?.viewerEmail;
  const t2 = sharedViewContext?.sessionToken;
  const t3 = sharedViewContext?.slug ?? "";
  let t4;
  if ($[0] !== shouldFilterByPropertyGroupIds || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== visibility) {
    t4 = getPublicSharedViewWorkspacePropertyGroupsQueryOptions({
      email: t1,
      sessionToken: t2,
      shouldFilterByPropertyGroupIds,
      slug: t3,
      visibility
    });
    $[0] = shouldFilterByPropertyGroupIds;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = visibility;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const sharedViewQuery = useQuery(t4);
  let t5;
  if ($[6] !== shouldFilterByPropertyGroupIds || $[7] !== visibility || $[8] !== workspaceId) {
    t5 = getWorkspacePropertyGroupsQueryOptions(workspaceId, shouldFilterByPropertyGroupIds, visibility);
    $[6] = shouldFilterByPropertyGroupIds;
    $[7] = visibility;
    $[8] = workspaceId;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const workspaceQuery = useQuery(t5);
  return sharedViewContext ? sharedViewQuery : workspaceQuery;
}